<template>
<div class="partner-view view">
    <div class="view-header"> <p class="m-2">Compliance</p></div>
    <div class="view-body d-flex flex-row">
        <side-bar :items="sidebarItems"></side-bar>
    </div>
</div>
</template>

<script>
import SideBar from '../framework/SideBar';

export default {
    components: {
        SideBar,
    },
    computed: {
        ...amfx.map('route', 'routePath:path,page'),
        sidebarItems() {
            return [];
        },
    },
    methods: {
        async load() {}
    },
    watch: {
        routePath: {
            handler: 'load',
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compliance/ComplianceView.vue